import { useCallback } from 'react';
import {
  OnboardingState,
  ONBOARDING_STORAGE_KEY,
} from '@/types/onboarding';

/**
 * Hook simplifié pour gérer le statut d'onboarding B8ild
 * Gère uniquement : complétion, vérification, réinitialisation
 */
export function useOnboarding() {
  /**
   * Marque l'onboarding comme complété
   */
  const completeOnboarding = useCallback(() => {
    const state: OnboardingState = {
      isCompleted: true,
      completedAt: new Date().toISOString(),
    };
    localStorage.setItem(ONBOARDING_STORAGE_KEY, JSON.stringify(state));
  }, []);

  /**
   * Vérifie si l'onboarding a été complété
   */
  const checkOnboardingCompleted = useCallback((): boolean => {
    const savedState = localStorage.getItem(ONBOARDING_STORAGE_KEY);
    if (!savedState) return false;
    try {
      const parsed: OnboardingState = JSON.parse(savedState);
      return parsed.isCompleted === true;
    } catch {
      return false;
    }
  }, []);

  /**
   * Réinitialise l'onboarding (pour "modifier mon métier" dans le profil)
   */
  const resetOnboarding = useCallback(() => {
    localStorage.removeItem(ONBOARDING_STORAGE_KEY);
  }, []);

  return {
    completeOnboarding,
    checkOnboardingCompleted,
    resetOnboarding,
  };
}
